import { Grid } from "@mantine/core";
import React from "react";

interface StyledGridColProps extends React.ComponentProps<typeof Grid.Col> {
  align?: string;
  justify?: string;
  textAlign?: string;
}

export const StyledGridCol: React.FC<StyledGridColProps> = ({
  align,
  justify,
  textAlign,
  style,
  ...rest
}) => (
  <Grid.Col
    style={{
      ...style,
      display: "flex",
      alignItems: align ?? "start",
      justifyContent: justify ?? "start",
      textAlign: textAlign as React.CSSProperties["textAlign"],
    }}
    {...rest}
  />
);
